import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import classNames from 'classnames';
import Dropdown from '../../components/molecules/Dropdown';
import TrashIcon from '../../resources/svg/trash.svg';
import { FILTER_TYPES, OUTER_LOGIC, OUTER_LOGIC_LABEL_EXTRA } from '../consts';
import ConditionEvent from './ConditionEvent';
import ConditionInstall from './ConditionInstall';
import ConditionNetwork from './ConditionNetwork';
import ConditionSession from './ConditionSession';
import css from './Edit.pcss';

const Filter = forwardRef((props, ref) => {
    const {
        index,
        filter,
        metadata,
        editFilter,
        deleteFilter,
        addCondition,
        editCondition,
        deleteCondition,
        apps,
        invalid,
        timesList,
        disabled,
    } = props;

    const container = useRef(null);

    useImperativeHandle(ref, () => ({
        getContainer: () => container,
        container,
    }));

    return (
        <div key={index} className={css.filter} ref={container}>
            <div className={classNames(css.dot, { [css.exclude]: filter.outer_logic === OUTER_LOGIC.exclude })} />
            <div className={css.flexRow} style={{ marginBottom: '6px' }}>
                <Dropdown
                    containerClass={css.outerLogic}
                    selected={{
                        name: filter.outer_logic,
                        display_name: OUTER_LOGIC[filter.outer_logic],
                    }}
                    onSelection={s => editFilter(index, 'outer_logic', s.name)}
                    items={Object.keys(OUTER_LOGIC).map(l => ({
                        name: l,
                        display_name: OUTER_LOGIC[l],
                    }))}
                    disabled={disabled}
                />
                <div className={css.outerLogicExtra}>
                    {filter.conditions.length > 1 ? OUTER_LOGIC_LABEL_EXTRA[filter.inner_logic] : 'users'}
                </div>
            </div>
            <div className={css.panel}>
                <div className={css.header}>
                    {filter.filter_type} Filter
                    {!disabled && (
                        <div className={css.trash} onClick={() => deleteFilter(index)}>
                            <TrashIcon />
                        </div>
                    )}
                </div>
                <div className={css.body}>
                    {filter.conditions.map((condition, cIndex) => {
                        if (filter.filter_type === FILTER_TYPES.EVENT) {
                            return (
                                <ConditionEvent
                                    key={condition.id ? condition.id : `condition_${index}_${cIndex}`}
                                    condition={condition}
                                    index={index}
                                    cIndex={cIndex}
                                    filter={filter}
                                    addCondition={addCondition}
                                    editCondition={editCondition}
                                    deleteCondition={deleteCondition}
                                    editFilter={editFilter}
                                    metadata={metadata}
                                    apps={apps}
                                    invalid={invalid}
                                    timesList={timesList}
                                    disabled={disabled}
                                />
                            );
                        } else if (
                            filter.filter_type === FILTER_TYPES.SESSION ||
                            filter.filter_type === FILTER_TYPES.REVENUE
                        ) {
                            return (
                                <ConditionSession
                                    key={`condition_${index}_${cIndex}`}
                                    condition={condition}
                                    index={index}
                                    cIndex={cIndex}
                                    filter={filter}
                                    addCondition={addCondition}
                                    editCondition={editCondition}
                                    deleteCondition={deleteCondition}
                                    metadata={metadata}
                                    editFilter={editFilter}
                                    invalid={invalid}
                                    timesList={timesList}
                                    disabled={disabled}
                                />
                            );
                        } else if (filter.filter_type === FILTER_TYPES.NETWORK) {
                            return (
                                <ConditionNetwork
                                    key={`condition_${index}_${cIndex}`}
                                    filter={filter}
                                    condition={condition}
                                    index={index}
                                    editFilter={editFilter}
                                    cIndex={cIndex}
                                    editCondition={editCondition}
                                    metadata={metadata}
                                    invalid={invalid}
                                    disabled={disabled}
                                />
                            );
                        }
                        return (
                            <ConditionInstall
                                key={`condition_${index}_${cIndex}`}
                                condition={condition}
                                index={index}
                                cIndex={cIndex}
                                filter={filter}
                                addCondition={addCondition}
                                editCondition={editCondition}
                                deleteCondition={deleteCondition}
                                editFilter={editFilter}
                                timesList={timesList}
                                disabled={disabled}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
});

export default Filter;
